import { useEffect, useState } from 'react';

import { Boundary, getBoundariesAtLocation } from '../../../api/fishrules/getBoundariesAtLocation';
import { ICoordinates } from '@app-types/geo';
import { reportMykissClientError } from '@lib/errors/client';

export type IBoundary = Boundary;

interface Result {
  isLoading: boolean;
  name?: string;
  boundaries?: IBoundary[];
}

function getBoundaryName(boundaries: Boundary[]): string | undefined {
  if (boundaries.length === 0) {
    return undefined;
  }

  // eslint-disable-next-line no-magic-numbers
  const boundariesWithoutRank10 = boundaries.filter(({ rank }) => rank !== 10);

  return boundariesWithoutRank10.length ? boundariesWithoutRank10[0]!.name : boundaries[0]!.name;
}

export function useRegulationBoundaryAtLocation(coords: ICoordinates | undefined): Result {
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState<string>();
  const [boundaries, setBoundaries] = useState<IBoundary[]>();

  const latitude = coords?.latitude;
  const longitude = coords?.longitude;

  useEffect(() => {
    const controller = new AbortController();
    // eslint-disable-next-line react-hooks/set-state-in-effect -- FIB-49117
    setIsLoading(true);

    if (latitude !== undefined && longitude !== undefined) {
      getBoundariesAtLocation({ latitude, longitude }, controller.signal)
        .then(boundaries => {
          if (boundaries.length) {
            setName(getBoundaryName(boundaries));
          }
          setBoundaries(boundaries);
          setIsLoading(false);
        })
        .catch((error: unknown) => {
          if (error instanceof Error && error.name !== 'AbortError') {
            reportMykissClientError(error);
          }
          setIsLoading(false);
        });
    }

    return () => {
      controller.abort();
    };
  }, [latitude, longitude]);

  return { isLoading, name, boundaries };
}
